// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Typography,
    MenuItem,
    Autocomplete
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';


import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import DialogDP from '../../../components/acc/DialogDP'
import { useToast } from '../../../components/ToastProvider'

import { getDesigner, getDoctag, getGudang, getProses } from '../../../api/helper';
import appInfo from '../../../configs/app-info';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])

    const [openDialog, setOpenDialog] = useState<boolean>(false)

    const [dialogMode, setDialogMode] = useState<string>('add')
    const [selectedData, setSelectedData] = useState<any>(null)

    const [kode, setKode] = useState('');
    const [designerId, setDesignerId] = useState(null);
    const [listDesigner, setListDesigner] = useState<any[]>([])
    const [valDesigner, setValDesigner] = useState<any>(null)

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [id, setId] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [openDialogAdd, setOpenDialogAdd] = useState<boolean>(false)

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.salesOrder, cabang, token);
            setListDoctag(response);
        };

        getData(tabs)
        fetchDoctag()
        fetchDesigner()
    }, [])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        let url = apiUrl.apiUrl + '/sales/sales-order/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDetail = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setDialogMode('edit')
                    setSelectedData(data)
                    setOpenDialog(true)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleChangeAutocompleteDesigner = (event: SyntheticEvent, newValue: any | null) => {
        setDesignerId(newValue ? newValue.id : null)
        setValDesigner(newValue)
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/sales-order/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/system/print/sdso/' + row.id, '_blank')
            },
            {
                title: "Nota Penjualan",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/sales/nota-penjualan/pdf/' + row.id, '_blank')
            },
            {
                title: "Hapus Sales Order",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };
    const ActionButtonsOutstanding = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<Icon icon="mdi:file-document-plus" />}
                    onClick={() => {
                        setId(row.id)
                        setValDoctag(null)
                        setOpenDialogAdd(true)
                    }}
                >
                    Buat Sales Order
                </Button>
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 180,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/sales/sales-order/detail/' + id)}
                />
            ),
        },
    ];

    const actionOutstanding = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsOutstanding
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/sales/sales-order/detail/' + id)}
                />
            ),
        },
    ];

    const convertComponent = [
        {
            key: 'dp_id',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.data.dp_id == null ? (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:file-document-plus" />}
                                onClick={() => {
                                    setDialogMode('add-from-list')
                                    console.log(row.data)
                                    setSelectedData(row.data)
                                    setOpenDialog(true)
                                }}
                            >
                                Buat DP
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:cash-fast" />}
                                onClick={() => {
                                    getDetail(row.data.dp_id)
                                }}
                            >
                                Bayar DP <br />
                                {row.data.dp_id}
                            </Button>
                        )}
                    </Box>
                )
            }
        },
        {
            key: 'preview',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                const documentNumber = row.data.preview?.split('/')[0] || row.data.preview;
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <div style={{ cursor: 'pointer' }} onClick={() => {
                            window.open(`/production/work-order/detail/${documentNumber}`, '_blank')
                        }}>
                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                {row.data.preview}
                            </Typography>
                        </div>
                    </Box>
                )
            }
        },
        {
            key: 'quotation',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                const documentNumber = row.data.quotation;
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <div style={{ cursor: 'pointer' }} onClick={() => {
                            window.open(`/sales/quotation/detail/${documentNumber}`, '_blank')
                        }}>
                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                {row.data.quotation}
                            </Typography>
                        </div>
                    </Box>
                )
            }
        }
    ];

    const fetchDesigner = async () => {
        const response = await getDesigner(cabang, token);
        setListDesigner(response);
    };

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='SALES ORDER' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/sales/sales-order/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData(tabs)}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Daftar Sales Order' />
                            <Tab value='1' label='Sales Order Belum Aktif' />
                            <Tab value='2' label='Outstanding Quotation' />
                        </TabList>
                        <TabPanel value='0'>
                            <MsiDatagrid array={listData} actions={actionData} customRender={convertComponent} hiddenColumns={['dokumen', 'sdcust_id', 'is_aktif', 'default_dp', 'default_dp_pesan']} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <MsiDatagrid array={listData} actions={actionOutstanding} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>

            <DialogDP
                key={selectedData?.id ?? 'add-from-list'}
                open={openDialog}
                mode={dialogMode}
                data={selectedData}
                doc_type={'sdso'}
                doc_id={selectedData?.id}
                onClose={() => {
                    setOpenDialog(false)
                    getData(tabs)
                }}
            />

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogAdd}
                onClose={() => setOpenDialogAdd(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Buat Sales Order
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3} component="form" onSubmit={(e) => {
                        e.preventDefault();
                        // Handle form submission

                        const payload = {
                            id_quotation: id,
                            sysdoctag_id: valDoctag,
                            kode: kode,
                            designer_id: designerId
                        }
                        const url = apiUrl.apiUrl + '/sales/sales-order/add-so-from-quotation'
                        axios
                            .post(url, payload, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                            .then(response => {
                                if (response.data.success) {
                                    const data = response.data.data[0]

                                    showToast(response.data.message, 'success');
                                    navigate('/sales/sales-order/detail/' + data.id)
                                } else {
                                    showToast(response.data.message, 'error');
                                }
                            })
                            .catch(error => {
                                showToast(error.message, 'error');
                            })
                    }}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label='Pilih Doctag'
                                    value={valDoctag}
                                    onChange={(e) => setValDoctag(e.target.value)}
                                >
                                    <MenuItem value="" disabled>Pilih Doctag</MenuItem>
                                    {listDoctag.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.nama}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Kode"
                                fullWidth
                                value={kode}
                                onChange={(e) => setKode(e.target.value)}
                                placeholder="Masukkan kode"
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    value={valDesigner}
                                    options={listDesigner}
                                    id='designer_id'
                                    isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                    onChange={handleChangeAutocompleteDesigner}
                                    getOptionLabel={(option: any) => option?.nama || ""}   // ?? penting
                                    renderOption={(props: any, option: any) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.nama}
                                            </li>
                                        )
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label='Designer'
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant='contained'
                                type='submit'
                                disabled={!valDoctag || !kode || !designerId}
                                fullWidth
                            >
                                Buat SO
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogAdd(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

        </Grid>
    )
}
